(function () {
  'use strict';
  function initializeSwipeGalleries() {
    document.querySelectorAll('[data-tcg-swipe-gallery]').forEach(function (gallery) {
      var viewport = gallery.querySelector('[data-tcg-swipe-viewport]');
      var slides = gallery.querySelectorAll('[data-tcg-swipe-slide]');
      var previous = gallery.querySelector('[data-tcg-swipe-previous]');
      var next = gallery.querySelector('[data-tcg-swipe-next]');
      var position = gallery.querySelector('[data-tcg-swipe-position]');
      var thumbnails = gallery.querySelector('[data-tcg-swipe-thumbnails]');
      var thumbnailButtons = Array.prototype.slice.call(gallery.querySelectorAll('[data-tcg-swipe-thumbnail]'));
      if (!viewport || slides.length < 2) return;
      var active = 0;
      var pending = 0;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function update(index, syncThumbnails) {
        var nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        var changed = nextIndex !== active;
        active = nextIndex;
        if (previous) previous.disabled = active === 0;
        if (next) next.disabled = active === slides.length - 1;
        if (position) position.textContent = (active + 1) + ' / ' + slides.length;
        thumbnailButtons.forEach(function (button, i) {
          var selected = i === active;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        if (syncThumbnails && changed && thumbnails && thumbnailButtons[active]) {
          var selectedButton = thumbnailButtons[active];
          var centeredLeft = selectedButton.offsetLeft - (thumbnails.clientWidth - selectedButton.clientWidth) / 2;
          thumbnails.scrollTo({ left: Math.max(0, centeredLeft), behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      }
      function go(index, instant) {
        var target = Math.max(0, Math.min(index, slides.length - 1));
        viewport.scrollTo({ left: target * viewport.clientWidth, behavior: (instant || reducedMotion) ? 'auto' : 'smooth' });
        update(target, true);
      }
      if (previous) previous.addEventListener('click', function () { go(active - 1, false); });
      if (next) next.addEventListener('click', function () { go(active + 1, false); });
      thumbnailButtons.forEach(function (button, i) {
        button.addEventListener('click', function () { go(i, false); });
      });
      viewport.addEventListener('scroll', function () {
        if (pending) return;
        pending = window.requestAnimationFrame(function () {
          pending = 0;
          if (viewport.clientWidth > 0) update(Math.round(viewport.scrollLeft / viewport.clientWidth), true);
        });
      }, { passive: true });
      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1, false); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1, false); }
      });
      window.addEventListener('resize', function () { go(active, true); });
      update(0, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSwipeGalleries);
  else initializeSwipeGalleries();
})();